import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/works',
    icon: 'ri-folders-line',
    title: '作品分类',
    desc: '按类型、年份与角色筛选，快速定位代表作。',
    count: '18 部作品',
  },
  {
    to: '/profile',
    icon: 'ri-user-star-line',
    title: '明星资料',
    desc: '基本资料、生平简介与代表作品一览。',
    count: '完整档案',
  },
  {
    to: '/news',
    icon: 'ri-newspaper-line',
    title: '影视动态',
    desc: '最新作品消息、深度解读与人物专访。',
    count: '10 条动态',
  },
];

export default function CategoryEntries() {
  return (
    <section className="container-page py-12 md:py-16">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative overflow-hidden rounded-lg border border-background-200/70 bg-background-100 p-6 transition-colors hover:border-primary-300 hover:bg-background-50 cursor-pointer"
          >
            <div className="flex items-start justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-700 text-background-50">
                <i className={`${entry.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
                {entry.count}
              </span>
            </div>
            <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
              {entry.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
            <span className="mt-5 inline-flex items-center gap-1 text-sm text-primary-700 transition-all group-hover:gap-2">
              进入栏目
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
            <i
              className={`${entry.icon} pointer-events-none absolute -bottom-6 -right-4 text-8xl text-primary-500/5`}
              aria-hidden="true"
            ></i>
          </Link>
        ))}
      </div>
    </section>
  );
}